module.exports = __webpack_public_path__ + "img/pc-mobile.3280147d.png";